module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Schoenenbuch-d4245b3f41e90ca20a8dae770d923dd7.png";